import { NewsletterEvent, NewsletterModalEvent } from 'store/googleTagManager/types';

const NewsletterInteractions = {
  SIGNUP: 'signup',
  DECLINE: 'decline',
  LATER: 'later'
};

export function getNewsletterModalLaterEvent(): NewsletterModalEvent {
  return {
    event: 'newsletter_modal',
    interaction: NewsletterInteractions.LATER
  };
}

export function getNewsletterModalDeclineEvent(): NewsletterModalEvent {
  return {
    event: 'newsletter_modal',
    interaction: NewsletterInteractions.DECLINE
  };
}

export function getNewsletterSignupEvent(signupPlacement: string): NewsletterEvent {
  return {
    event: 'newsletter_signup',
    signup_placement: signupPlacement
  };
}
